module.exports = function() {

  /**
   *  Validates a number is an integer.
   *
   *  @param cb The callback function.
   */
  this.main.integer = function integer(cb) {
    if(this.validates()) {
      this.required();
      this.type();
      this.range();
    }
    cb();
  }

}



//////////////////
// WEBPACK FOOTER
// ../node_modules/async-validate/plugin/integer.js
// module id = 1374
// module chunks = 93